import React, { useRef, useEffect, useState } from 'react';
import { withFeatureSafe } from 'Common/ErrorBoundaries';

const SlidingTabs = ({
    children,
    activeTab,
    extraClass,
    extraStyle,
    extraItem = 0,
    activeColor = 'bg-primary2',
}) => {
    const tabRefs = useRef([]);
    const [animationStyle, setAnimationStyle] = useState({ width: '0px', left: '0px' });

    useEffect(() => {
        const activeTabIndex = tabRefs.current.findIndex(tab => tab?.dataset?.value === activeTab.toString());
        if (activeTabIndex !== -1 && tabRefs.current[activeTabIndex]) {
            const activeTabElement = tabRefs.current[activeTabIndex];
            const width = activeTabElement.offsetWidth;
            const left = activeTabElement.offsetLeft;
            setAnimationStyle({
                width: `${width + extraItem}px`,
                left: `${left}px`,
            });

        }
    }, [activeTab, children]);

    const BASE_CLASSES = 'w-full sm:flex-row border-b-[1px] flex flex-row gap-12 relative';
    const resolvedClasses = extraClass ? `${BASE_CLASSES} ${extraClass}` : `${BASE_CLASSES} bg-white`;

    return (
        <ul className={resolvedClasses} style={extraStyle}>
            {React.Children.map(children, (child, index) => (

                React.cloneElement(child, {
                    ref: el => tabRefs.current[index] = el,
                    'data-value': child.props.value,
                    key: child.props.value || index
                })
            ))}
            <div
                className={`absolute bottom-0 transition-all duration-300 ease-in-out ${activeColor} `}
                style={{ ...animationStyle, height: '2px' }}
            />
        </ul>
    );
};

export default withFeatureSafe(SlidingTabs);